import { ISlotCombinedPattern, ISlotPattern } from "./types/IPositionPatterns";

export function slotIdJoinedToMixed(pos: ISlotPattern): ISlotCombinedPattern {
  return `${pos.substring(0, 2)}|${pos.substring(2)}` as ISlotCombinedPattern;
}

export function slotIdMixedToJoined(pos: ISlotCombinedPattern): ISlotPattern {
  return pos.split("|").join("") as ISlotPattern;
}
